<roots-page-header
  [toolTip]="_config.toolTip"
  [title]="_config.title"
  [loading]="_config.loading"
  [items]="actionButtons"
  (refresh)="refresh()"
  (actionListClicked)="actionsClicked($event)"
>
</roots-page-header>
<roots-actionable-table
  [actionColumns]="actionColumns"
  [dataSource]="_config.dataSource"
  [filter]="_config.message"
  [csv]="_config.title"
  (actionsClicked)="actionsClicked($event)">
</roots-actionable-table>